import { render, staticRenderFns } from "./filter-button.vue?vue&type=template&id=493a2e97&scoped=true&"
import script from "./filter-button.vue?vue&type=script&lang=js&"
export * from "./filter-button.vue?vue&type=script&lang=js&"
import style0 from "./filter-button.vue?vue&type=style&index=0&id=493a2e97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a2e97",
  null
  
)

export default component.exports